import HomeRecommendation from './HomeRecommendation';

export default HomeRecommendation;